<template>
  <main class="exap-paper">
    <div style="text-align: right">
      <el-button
        size="small"
        @click="handleAddClick"
        v-if="functionList.includes('327328636826521600')"
      >新增问卷</el-button>
    </div>
    <el-table
      border
      :data="tableData"
    >
      <template slot="empty">{{emptyText}}</template>
      <el-table-column
        v-for="col in tableLabelList"
        :key="col.prop"
        :prop="col.prop"
        :width="col.width"
        :formatter="formatter"
        :label="col.label"
      ></el-table-column>
      <el-table-column
        width="150"
        label="操作"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="handleToggleStatusClick(scope.row)"
              v-if="functionList.includes('327329328458862592') && scope.row.status==='0'"
            >启用</span>
            <span
              class="button--blue"
              @click="handleEditClick(scope.row)"
              v-if="functionList.includes('327328840757776384')"
            >编辑</span>
            <span
              class="button--red"
              @click="handleDeleteClick(scope.row)"
              v-if="functionList.includes('327329573800480768')"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </main>
</template>
<script>
import { addNav, getPagingData, getFunctionList } from '@/mixins';

export default {
  name: 'ExamPaper',

  mixins: [addNav, getPagingData, getFunctionList],
  data() {
    const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      userId,
      emptyText: this.$LS.empty,
      currentPage: 1,
      sumCount: 0,
      tableData: [],
      functionList: [],
      statusMap: {
        0: '禁用',
        1: '启用',
      },
      tableLabelList: [{
        prop: 'id',
        label: '问卷ID',
        width: 200,
      }, {
        prop: 'name',
        label: '问卷名称',
        width: 200,
      }, {
        prop: 'totalQuestion',
        label: '题目数',
        width: 100,
      }, {
        prop: 'totolScore',
        label: '总分值',
        width: 100,
      }, {
        prop: 'validPeriod',
        label: '有效期',
        width: 180,
      }, {
        prop: 'status',
        label: '状态',
        width: 100,
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: 200,
      }, {
        prop: 'createUserid',
        label: '创建人ID',
        width: 200,
      }, {
        prop: 'updateTime',
        label: '更新时间',
        width: 200,
      }, {
        prop: 'updateUserid',
        label: '更新人ID',
        width: 200,
      }],
    };
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.getTableData();
      },
    },
  },
  activated() {
    this.getTableData();
  },
  methods: {
    formatter(row, col, value) {
      const time = ['createTime', 'updateTime'];
      if (time.includes(col.property)) {
        return this.formatTime(value);
      }
      if (col.property === 'status') {
        return this.statusMap[value] || '-';
      }
      if (col.property === 'validPeriod') {
        return `${value}个月`;
      }
      if (value === 0) {
        return value;
      }
      return value || '-';
    },
    getTableData() {
      this.getPagingData(this.$API.listQuestionnaire);
    },
    handleToggleStatusClick(data) {
      this.$_yh_confirm('确定新的问卷', '启用问卷').then(() => {
        this.toggleStatus(data);
      });
    },
    toggleStatus(data) {
      return this.$_post(this.$API.updateQuestionnaireStatus, {
        data: {
          id: data.id,
          status: '1',
          updateUserid: this.userId,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0056);
          this.getTableData();
        } else {
          this.$message.error(this.$MSG.M0057);
        }
      });
    },
    handleEditClick(data) {
      if (data.status === '1') {
        this.$message.warning(this.$MSG.M0139);
      } else {
        this.addNav({
          path: '/edit-exam-paper',
          name: '编辑问卷',
          query: {
            id: data.id,
          },
        });
      }
    },
    deleteQuestionnaire(id) {
      return this.$_post(this.$API.deleteQuestionnaire, {
        data: {
          id,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0137);
          this.getTableData();
        } else {
          this.$message.warning(this.$MSG.M0138);
        }
      });
    },
    handleDeleteClick(data) {
      this.$_yh_confirm('确定删除问卷，启用中的问卷无法删除', '删除问卷').then(() => {
        if (data.status === '1') {
          this.$message.warning(this.$MSG.M0138);
        } else {
          this.deleteQuestionnaire(data.id);
        }
      });
    },
    handleAddClick() {
      this.addNav({
        path: '/add-exam-paper',
        name: '新增问卷',
      });
    },
  },
};
</script>
